import Axios from './axios'
import { db, serverTimestamp } from '@src/firebase'
import addToaster from '@shared/Notification'
import { use } from 'react'

/** get agora token useing channel
 * @param {Object} payload
 * @param {String} payload.channel
 */
// export const callAddPaymentOrderApi = payload => {
//   return Axios.post('/payments/order', payload)
// }

export const callRazorpayAddPaymentOrderApi = payload => {
  return Axios.post('/razorpay/order', payload)
}

export const callGpayAddPaymentOrderApi = payload => {
  return Axios.post('/gpay/order', payload)
}

export const callPaypalAddPaymentOrderApi = payload => {
  return Axios.post('/paypal/order', payload)
}

export const callPaypalGetPaymentOrderApi = payload => {
  return Axios.post('/paypal/success', payload)
}

export const callPaypalCreatePayoutApi = payload => {
  return Axios.post('/paypal/payout', payload)
}

export const callPaypalGetPayoutApi = payload => {
  return Axios.get(`/paypal/payout?payoutId=${payload}`)
}

export const callStripeAddPaymentOrderApi = payload => {
  return Axios.post('/stripe/checkout/session', payload)
}

export const callStripePaymentStatusApi = (stripeSessionId, userId) => {
  return Axios.get(`/stripe/payment-status?stripeSessionId=${stripeSessionId}&userId=${userId}`)
}

export const callStripeAccountOnboardApi = (payload) => {
  return Axios.post('/stripe/onboard/account', payload);
}

export const callGetStripeAccountApi = (userId) => {
  return Axios.get(`/stripe/account/${userId}`);
}

export const callStripeAccountLinkApi = payload => {
  return Axios.post('/stripe/account/link', payload)
}

export const callStripeCreatePayoutApi = payload => {
  return Axios.post('/stripe/payout', payload)
}

export const callAddTransactionWalletApi = async (userId, docId, payload) => {
  try {
    await db
      .collection(`users/${userId}/transactions`)
      .doc(docId)
      .set({ ...payload, createdAt: serverTimestamp }, { merge: true })
    return { status: 200 }
  } catch (error) {
    addToaster('error', error.message)
  }
}

export const callAddAccountApi = async (userId, docId, payload) => {
  try {
    await db
      .collection(`users/${userId}/accounts`)
      .doc(docId)
      .set({ ...payload, createdAt: serverTimestamp }, { merge: true })
    return { status: 200 }
  } catch (error) {
    addToaster('error', error.message)
  }
}

export const callGetAccountApi = async (userId, docId, resData) => {
  db.collection(`users/${userId}/accounts`).onSnapshot(snapshot => {
    if (snapshot.empty) resData([])
    else {
      const accounts = snapshot.docs.map(item => {
        const id = item.id
        return { ...item.data(), id }
      })
      resData(accounts)
    }
  })
}

/** Get Transactions using user userId
 * @param {Object} payload.userId
 * * @param {Object} payload.resData callback function for res Data
 */
export const callGetRealtimeTransactionsApi = (userId, resData) => {
  db.collection(`users/${userId}/transactions`).orderBy('createdAt', 'desc').onSnapshot(snapshot => {
    if (snapshot.empty) resData([])
    else {
      const transactions = snapshot.docs.map(item => {
        const id = item.id
        return { ...item.data(), id }
      })
      resData(transactions)
    }
  })
}

export const callAddWithdrawalRequestApi = async (userId, payload) => {
  try {
    await db
      .collection('withdrawRequest')
      .doc(userId)
      .set({ ...payload, isCompleted: false, createdAt: serverTimestamp }, { merge: true })
    return { status: 200 }
  } catch (error) {
    addToaster('error', error.message)
  }
}